import { RadioGroup } from "@frends/ui-components/react";

export default RadioGroup;
